export enum CallTypes {
  Video = 'video',
  Phone = 'phone',
}
